import {
  Component,
  ComponentFactoryResolver,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { KpiStatsHostDirective } from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-stats-host.directive';
import { KpiStatsItem } from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-stats-item';
import { PilotKpiStatsViewComponent } from './pilot-kpi-stats-view.component';

@Component({
  selector: 'fl-pilot-kpi-stats',
  template: `
    <div class="kpi-stats-container">
      <ng-template flKpiStatsHost></ng-template>
    </div>
  `,
  styles: ['.kpi-stats-container { margin: 8px; padding: 3px 0; }'],
})
export class PilotKpiStatsViewBuilderComponent implements OnChanges {
  @Input()
  public stats: KpiStatsItem[];
  @ViewChild(KpiStatsHostDirective, { static: true })
  public statsHost: KpiStatsHostDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.stats.currentValue !== changes.stats.previousValue) {
      this.loadComponents();
    }
  }

  public loadComponents() {
    if (this.stats != null) {
      this.stats.forEach((statsItem) => {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
          statsItem.component,
        );
        const viewContainerRef = this.statsHost.viewContainerRef;
        const componentRef = viewContainerRef.createComponent(componentFactory);
        const component = componentRef.instance as PilotKpiStatsViewComponent;
        component.displaySize = 'small';
        component.data = statsItem.data;
      });
    }
  }
}
